import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AccessManagerService } from '../auth/accessManager/accessManager.service';
import { AccessManagerResourceActionType } from "../auth/accessManager/accessManager.models";
import { DashboardCfgService } from '../dashboard/dashboardCfg.service';
import { ModalDialogComponent } from '../common/modal/modalDialog.component';
import { ApigeeService } from '../auth/apigee/apigee.service';
import { GestorService } from '../auth/accessManager/gestor.service';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
  standalone: false
})
export class LoginComponent implements OnInit {

  @ViewChild(ModalDialogComponent, { static: true }) private dialog: ModalDialogComponent;

  private mBusy: boolean = false;

  errorUserDataMsg = '';

  constructor(private router: Router,
    private apigeeService: ApigeeService,
    private accessManagerService: AccessManagerService,
    private zone: NgZone,
    private dashboardCfg: DashboardCfgService,
    private gestorService: GestorService) { }

  public get busy(): boolean {
    return this.mBusy;
  }

  public ngOnInit() {

    this.errorUserDataMsg = '';

    if (this.apigeeService.googleAuthToken != null && this.apigeeService.googleDirectoryToken != null && this.apigeeService.apiToken != null) {
      this.zone.run(() => this.mBusy = true);
      let promise = this.accessManagerService.getResourcePermissions(this.dashboardCfg.getCfg().resourceId)
        .then((permissions) => {
          if (permissions && permissions.getResourceAction(AccessManagerResourceActionType.ApplicationAccess)) {
            this.zone.run(() => this.router.navigate(['dashboard']));
          }
          else {
            this.zone.run(() => this.router.navigate(['home']));
          }

          return Promise.resolve();
        }).catch((error) => {
          return Promise.reject(error);
        });

      const roles$ = this.apigeeService.getUserInfoApi().pipe(
        switchMap(() => this.gestorService.getRolesApi())
      );

      roles$.subscribe(async data => {
        this.errorUserDataMsg = this.apigeeService.isTokenValid();

        if (this.errorUserDataMsg != '' || data.length == 0) {
          let tokenError = 'Su usuario no tiene autorización para acceder a FBi (configuración de Gestor). Informa por NACS área Servidesk IT';
          this.errorUserDataMsg = this.errorUserDataMsg != '' ? this.errorUserDataMsg : tokenError;
          this.apigeeService.clearToken();
          this.dialog.open();
        } else {
          await promise;
        }

        this.zone.run(() => this.mBusy = false);
      }, () => {
        this.apigeeService.clearToken();
      });
    }
  }
}
